<template>
  <Navbar v-if="!hideAppChrome" />
  <div class="container-custom">
    <router-view :key="$route.name" />
  </div>
  <FooterComponents v-if="!hideAppChrome" />
</template>

<script>
import Navbar from "./components/Navbar.vue";
import FooterComponents from "./components/FooterComponents.vue";

export default {
  name: "App",
  components: {
    FooterComponents,
    Navbar,
  },
  computed: {
    hideAppChrome() {
      return this.$route.name === "qrscanner";
    },
  },
  mounted() {
    document.title = "LETMEIN: Smart Living and Workplace Platform";
    const link = document.querySelector("[rel='icon']");
    link.setAttribute("href", "icon.png");
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@400;500;700&display=swap");

#app {
  font-family: "Kanit", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  margin: 0;
  height: 100%;
  overflow-x: hidden;
  /* overflow: hidden; */
  position: relative;
}

html {
  overflow-x: hidden;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.payment-header {
  width: 100%;
  font-family: "Kanit", sans-serif;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.05;
  letter-spacing: normal;
  text-align: left;
  color: #2dc86e;
  display: inline;
  margin-right: 2%;
}

.payment-success {
  display: inline;
  width: 50px;
  height: 45px;
}

.payment-text {
  font-family: "Kanit", sans-serif;
  font-size: 14px;
  line-height: 2;
}

.label-btn {
  font-family: "Kanit", sans-serif;
  font-size: 15px;
  margin: 0px;
}

.btn-payment {
  background-color: #001c41;
  color: white;
  padding: 5px;
  margin-top: 40px;
  width: 100%;
  border-radius: 5px;
  border: none;
}

.btn-payment:hover {
  background-color: #001c41;
  color: white;
}

.btn-payment:disabled {
  background-color: #9aa5b1;
  color: white;
  padding: 5px;
  margin-top: 40px;
  width: 100%;
  border-radius: 5px;
  border: none;
}

.container-custom {
  max-width: 768px;
  width: 100%;
  margin: auto;
}
</style>
